var React = require('react');

function TeamHeroFlag1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m2.95011259 171.519966 934.65945241-539.625625 101.497705 591.510683-754.650969 435.697726z","fill":"#eaf4f3","fillRule":"evenodd","opacity":".535203","transform":"matrix(.8660254 .5 -.5 .8660254 83.553881 -241.686205)"}));
}

TeamHeroFlag1.defaultProps = {"height":"472","preserveAspectRatio":"none","viewBox":"0 0 1046 472","width":"1046"};

module.exports = TeamHeroFlag1;

TeamHeroFlag1.default = TeamHeroFlag1;
